import React, { Component} from 'react';
import '../styles/citation.scss';
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
import Citation from '../models/Citation'
import StringHelper from '../utils/stringHelper'

class CitationComponentDelegate {
  constructor() {

  }

  citationComponentDidCancel(citationComponent) {

  }
}

class CitationComponent extends Component {
  constructor() {
    super();
  }

  componentWillMount() {

  }

  // CitationComponentDelegate
  delegate() {
    return this.props.delegate;
  }

  //
  citation() {
    return this.props.citation;
  }

  handleCancelClicked(event) {
    if (this.delegate() != null) {
      this.delegate().citationComponentDidCancel(this);
    }
  }

  render() {
    return (
      <div className="citationContainer">
        <img src={require("../images/cancel@2x.png")} className="citationCancelButton" onClick={this.handleCancelClicked.bind(this)} />
        <div className="citationText" dangerouslySetInnerHTML={{__html:StringHelper.linkify(this.citation().text)}}></div>
      </div>
    );
  }

}

export default CitationComponent;



/** WEBPACK FOOTER **
 ** ./src/components/CitationComponent.js
 **/